import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PostulantCreate } from './postulant-create';
import { PostulantEdit } from './postulant-edit';

export const PostulantFormRoutes = ({ cloudflareRecaptcha }) => {
  return (
    <Router>
      <Routes>
        <Route
          path='/:typePortal/get_vacancy/:vacancyId/candidates/new'
          element={<PostulantCreate key='new' cloudflareRecaptcha={cloudflareRecaptcha} />}
        />

        {/* Renderización del formulario desde micrositios */}
        <Route
          path='/:typePortal/microsite/:micrositeName/:vacancyId/new'
          element={<PostulantCreate key='new-microsite' />}
        />

        {/* Renderización del formulario desde el portal interno */}
        <Route
          path='/:typePortal/get_vacancy/:vacancyId/candidates/new'
          element={<PostulantCreate key='new-interno' />}
        />

        <Route
          path='/app/postulant/update/:postulantId'
          element={<PostulantEdit key='update' cloudflareRecaptcha={cloudflareRecaptcha} />}
        />
      </Routes>
    </Router>
  );
};
